module.exports = __webpack_public_path__ + "img/close.41a74d46.svg";